import { Field, FieldType } from 'src/config';


const FILTER_NEGATE = 'filter/FILTER_NEGATE';
const FILTER_ADD_AFTER = 'filter/FILTER_ADD_AFTER';
const FILTER_ADD_BEFORE = 'filter/FILTER_ADD_BEFORE';
const FILTER_REMOVE = 'filter/FILTER_REMOVE';
const FILTER_SET_LOG_OP = 'filter/FILTER_SET_LOG_OP';
const FILTER_SELECT = 'filter/FILTER_SELECT';
const FILTER_GROUP = 'filter/FILTER_GROUP';
const FILTER_EXPLODE = 'filter/FILTER_EXPLODE';
const FILTER_SET_OP = 'filter/FILTER_SET_OP';
const FILTER_SET_DISABLED = 'filter/FILTER_SET_DISABLED';
const FILTER_SET_PATH = 'filter/FILTER_SET_PATH';
const FILTER_SET_FUNC = 'filter/FILTER_SET_FUNC';
const FILTER_REMOVE_FUNC = 'filter/FILTER_REMOVE_FUNC';
const FILTER_SET_LITERAL = 'filter/FILTER_SET_LITERAL';
const FILTER_RESET = 'filter/FILTER_RESET';
const FILTER_SET_EXPRESSION = 'filter/FILTER_SET_EXPRESSION';


export {
    FILTER_NEGATE,
    FILTER_ADD_AFTER,
    FILTER_ADD_BEFORE,
    FILTER_REMOVE,
    FILTER_SET_LOG_OP,
    FILTER_SELECT,
    FILTER_GROUP,
    FILTER_EXPLODE,
    FILTER_SET_OP,
    FILTER_SET_DISABLED,
    FILTER_SET_PATH,
    FILTER_SET_FUNC,
    FILTER_REMOVE_FUNC,
    FILTER_SET_LITERAL,
    FILTER_RESET,
    FILTER_SET_EXPRESSION,
}

export interface ConditionOp {
    name: string;
    label: string;
    arity: number;
}

const eqOp: ConditionOp = { name: 'eq', label: 'Equals', arity: 1 };

export const genericOps: ConditionOp[] = [
    eqOp,
    { name: 'ne', label: 'Not Equals', arity: 1 },
    { name: 'isNull', label: 'Is Null', arity: 0 },
    { name: 'isNotNull', label: 'Is Not Null', arity: 0 },
    { name: 'gt', label: 'Greater', arity: 1 },
    { name: 'goe', label: 'Greater/Equals', arity: 1 },
    { name: 'lt', label: 'Less', arity: 1 },
    { name: 'loe', label: 'Less/Equals', arity: 1 },
];

export const stringOps: ConditionOp[] = [
    { name: 'contains', label: 'Contains', arity: 1 },
    { name: 'containsIgnoreCase', label: 'Contains Ignore Case', arity: 1 },
    { name: 'startsWith', label: 'Starts With', arity: 1 },
    { name: 'startsWithIgnoreCase', label: 'Starts With Ignore Case', arity: 1 },
    { name: 'endsWith', label: 'Ends With', arity: 1 },
    { name: 'endsWithIgnoreCase', label: 'Ends With Ignore Case', arity: 1 },
    { name: 'equalsIgnoreCase', label: 'Equals Ignore Case', arity: 1 },
    { name: 'notEqualsIgnoreCase', label: 'Not Equals Ignore Case', arity: 1 },
    { name: 'isEmpty', label: 'Is Empty', arity: 0 },
    { name: 'isNotEmpty', label: 'Is Not Empty', arity: 0 },
    { name: 'like', label: 'Like', arity: 1 },
    { name: 'notLike', label: 'Not Like', arity: 1 },
    { name: 'likeIgnoreCase', label: 'Like Ignore Case', arity: 1 },
    { name: 'matches', label: 'Matches', arity: 1 },
];

export const dateTimeOps: ConditionOp[] = [
    { name: 'after', label: 'After', arity: 1 },
    { name: 'before', label: 'Before', arity: 1 },
]

// export type GenericLogOp = 'eq' | 'ne' | 'isNull' | 'isNotNull' | 'gt' | 'goe' | 'lt' | 'loe';
// export type StringLogOp = 'contains' | 'containsIgnoreCase' | 'startsWith' | 'startsWithIgnoreCase' | 'endsWith' | 'endsWithIgnoreCase' | 'equalsIgnoreCase' | 'notEqualsIgnoreCase' | 'isEmpty' | 'isNotEmpty' | 'like' | 'notLike' | 'likeIgnoreCase' | 'matches';
// export type DateTimeLogOp = 'after' | 'before';

// export const AllGenericLogOps: GenericLogOp[] = ['eq', 'ne', 'isNull', 'isNotNull', 'gt', 'goe', 'lt', 'loe'];
// export const AllStringLogOp: StringLogOp[] = ['contains', 'containsIgnoreCase', 'startsWith', 'startsWithIgnoreCase', 'endsWith', 'endsWithIgnoreCase', 'equalsIgnoreCase', 'notEqualsIgnoreCase', 'isEmpty', 'isNotEmpty', 'like', 'notLike', 'likeIgnoreCase', 'matches'];
// export const AllDateTimeLogOp: DateTimeLogOp[] = ['after', 'before'];


// export type DateTimeOp = 'today' | 'yesterday' | 'this_week' | 'this_month' | 'this_year' | 'last_week' | 'last_month' | 'last_year';
// export type DateTimeOp = 'dayOfMonth' | 'dayOfWeek' | 'dayOfYear' | 'hour' | 'milliSecond' | 'minute' | 'month' | 'second' | 'week' | 'year' | 'yearMonth' | 'yearWeek';

// export type Op = GenericLogOp | StringLogOp | DateTimeLogOp;



export enum LogOp {
    and,
    or
}

export enum ExpSide {
    left,
    right
}

export const defaultOp: ConditionOp = eqOp;
export const defaultLogOp: LogOp = LogOp.or;

// -------------------------------------------------------------------

export interface FuncArgPathEntry {
    depth: number;
    argIndex: number;
}

export type FuncArgPath = FuncArgPathEntry[];

export interface Literal {
    value: string;
}

export enum PathType {
    Boolean,
    Date,
    Number,
    String,
}

export const typesMap: { [key in FieldType]: PathType } = {
    [FieldType.BOOLEAN]: PathType.Boolean,

    [FieldType.DATE]: PathType.Date,
    [FieldType.DATE_TIME]: PathType.Date,

    [FieldType.DOUBLE]: PathType.Number,
    [FieldType.FLOAT]: PathType.Number,
    [FieldType.INT32]: PathType.Number,
    [FieldType.INT64]: PathType.Number,

    [FieldType.STRING]: PathType.String,
    [FieldType.TEXT]: PathType.String,
    [FieldType.PASSWORD]: PathType.String,
}

// export type ExpressionFunctionArg = Literal | ExpressionPath;
export type ExpressionFunctionArg = ExpressionPath;

export interface ExpressionFunctionSpec {
    name: string;
    args: PathType[];
    returns: PathType;
}


export const specsToTypes: { [key in PathType]: ExpressionFunctionSpec[] } = {
    [PathType.Boolean]: [

    ],
    [PathType.Date]: [
        {
            name: 'minute',
            args: [],
            returns: PathType.Number
        },
        {
            name: 'month',
            args: [],
            returns: PathType.Number
        },
        {
            name: 'second',
            args: [],
            returns: PathType.Number
        },
        {
            name: 'week',
            args: [],
            returns: PathType.Number
        },
        {
            name: 'year',
            args: [],
            returns: PathType.Number
        },
        {
            name: 'yearMonth',
            args: [],
            returns: PathType.Number
        },
        {
            name: 'yearWeek',
            args: [],
            returns: PathType.Number
        },
    ],
    [PathType.Number]: [
        {
            name: 'abs',
            args: [],
            returns: PathType.Number
        },
        {
            name: 'add',
            args: [PathType.Number],
            returns: PathType.Number
        },
        {
            name: 'ceil',
            args: [],
            returns: PathType.Number
        },
        {
            name: 'divide',
            args: [PathType.Number],
            returns: PathType.Number
        },
        {
            name: 'floor',
            args: [],
            returns: PathType.Number
        },
        {
            name: 'mod',
            args: [PathType.Number],
            returns: PathType.Number
        },
        {
            name: 'multiply',
            args: [PathType.Number],
            returns: PathType.Number
        },
        {
            name: 'negate',
            args: [],
            returns: PathType.Number
        },
        {
            name: 'round',
            args: [],
            returns: PathType.Number
        },
        {
            name: 'sqrt',
            args: [],
            returns: PathType.Number
        },
        {
            name: 'subtract',
            args: [PathType.Number],
            returns: PathType.Number
        },
    ],
    [PathType.String]: [
        {
            name: 'append',
            args: [PathType.String],
            returns: PathType.String
        },
        {
            name: 'concat',
            args: [PathType.String],
            returns: PathType.String
        },
        {
            name: 'indexOf',
            args: [PathType.String],
            returns: PathType.Number
        },
        {
            name: 'indexOf',
            args: [PathType.String, PathType.Number],
            returns: PathType.Number
        },
        {
            name: 'length',
            args: [],
            returns: PathType.Number
        },
        {
            name: 'locate',
            args: [PathType.String],
            returns: PathType.Number
        },
        {
            name: 'locate',
            args: [PathType.String, PathType.Number],
            returns: PathType.Number
        },
        {
            name: 'lower',
            args: [],
            returns: PathType.String
        },
        {
            name: 'upper',
            args: [],
            returns: PathType.String
        },
        {
            name: 'toLowerCase',
            args: [],
            returns: PathType.String
        },
        {
            name: 'toUpperCase',
            args: [],
            returns: PathType.String
        },
        {
            name: 'prepend',
            args: [PathType.String],
            returns: PathType.String
        },
        {
            name: 'substring',
            args: [PathType.Number],
            returns: PathType.String
        },
        {
            name: 'substring',
            args: [PathType.Number, PathType.Number],
            returns: PathType.String
        },
        {
            name: 'trim',
            args: [],
            returns: PathType.String
        },
    ],
}

export interface ExpressionFunction {
    spec: ExpressionFunctionSpec;
    args: ExpressionFunctionArg[];
}

export interface ExpressionPath {
    path: string | ExpressionPath | Literal;
    field?: Field;
    func?: ExpressionFunction
}

export interface PathLocation {
    filterPath: FilterPath
    side: ExpSide
    argPath: FuncArgPath
    depth?: number
    rhsIndex?: number
}

export function isExpressionPath(expPath: any): expPath is ExpressionPath {
    return expPath.path !== undefined;
}

export function isLiteral(literal: any): literal is Literal {
    return literal.value !== undefined;
}

// -------------------------------------------------------------------

export interface Selectable {
    selected: boolean;
}

export interface Negatable {
    negated: boolean;
}

export interface Exp extends Negatable, Selectable {
    lhs: ExpressionPath;
    op: ConditionOp;
    rhs: ExpressionPath[];
}

export interface Expression extends Exp {
    items: Expression[];
    ops: LogOp[];
}

export type FilterPath = number[];

// -------------------------------------------------------------------

export interface FilterNegateAction {
    type: typeof FILTER_NEGATE
    path: FilterPath
    value: boolean
}

export interface FilterSelectAction {
    type: typeof FILTER_SELECT
    path: FilterPath
    value: boolean
}

export interface FilterAddAfterAction {
    type: typeof FILTER_ADD_AFTER
    path: FilterPath
}

export interface FilterAddBeforeAction {
    type: typeof FILTER_ADD_BEFORE
    path: FilterPath
}

export interface FilterRemoveAction {
    type: typeof FILTER_REMOVE
    path: FilterPath
}

export interface FilterSetLogOpAction {
    type: typeof FILTER_SET_LOG_OP
    path: FilterPath
    index: number
    op: LogOp
}

export interface FilterGroupAction {
    type: typeof FILTER_GROUP
    path: FilterPath
}

export interface FilterExplodeAction {
    type: typeof FILTER_EXPLODE
    path: FilterPath
}

export interface FilterSetOpAction {
    type: typeof FILTER_SET_OP
    path: FilterPath
    op: ConditionOp
}

export interface FilterSetDisabledAction {
    type: typeof FILTER_SET_DISABLED
    value: boolean
}

export interface FilterSetPathAction {
    type: typeof FILTER_SET_PATH
    pathLocation: PathLocation
    attr: string
    field: Field
}

export interface FilterSetFuncAction {
    type: typeof FILTER_SET_FUNC
    pathLocation: PathLocation
    spec: ExpressionFunctionSpec
}

export interface FilterRemoveFuncAction {
    type: typeof FILTER_REMOVE_FUNC
    pathLocation: PathLocation
}

export interface FilterSetLiteralAction {
    type: typeof FILTER_SET_LITERAL
    pathLocation: PathLocation
    value: string
}

export interface FilterResetAction {
    type: typeof FILTER_RESET
}

export interface FilterSetExpressionAction {
    type: typeof FILTER_SET_EXPRESSION
    expression: Expression
}

// -------------------------------------------------------------

export interface FilterState {
    expression: Expression
    disabled: boolean
}

export type FilterActions =
    FilterNegateAction
    | FilterSelectAction
    | FilterAddAfterAction
    | FilterAddBeforeAction
    | FilterRemoveAction
    | FilterSetLogOpAction
    | FilterGroupAction
    | FilterExplodeAction
    | FilterSetOpAction
    | FilterSetDisabledAction
    | FilterSetPathAction
    | FilterSetFuncAction
    | FilterRemoveFuncAction
    | FilterSetLiteralAction
    | FilterResetAction
    | FilterSetExpressionAction
